'use strict';
/* eslint-disable */
const $ = jQuery.noConflict();
$(function() {

	const infoBlock = {

		init: function() {
            const isDesktop = window.innerWidth > 1199;
            $('.info-block__box-card-media').each(function() {
                const $wrapper = $(this).find('.hover-video-wrapper');
                const video = $wrapper.find('.hover-video')[0];

                if (!video) return;

                video.muted = true;
                video.loop = true;
                video.playsInline = true;

                if (isDesktop) {
                    video.pause();
                    $wrapper.on('mouseenter', function() {
                        video.play().catch(() => {});
                    });
                    $wrapper.on('mouseleave', function() {
                        video.pause();
                    });
                } else {
                    const observer = new IntersectionObserver((entries) => {
                        entries.forEach(entry => {
                            if (entry.isIntersecting) {
                                video.play().catch(() => {
                                    $(document).one('touchstart', function () {
                                        video.play().catch(() => {});
                                    });
                                });
                            } else {
                                video.pause();
                            }
                        });
                    }, { threshold: 0.5 });

                    observer.observe(video);
                }
            });
        },
	};

	infoBlock.init();
});
